import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';

const centerUrl = `${baseGrtURL}/api/grt-user-center-service`;

export const url = {
    courseDetail: `${centerUrl}/agent/course/courseware/ai/details`, //获取课件
    firstCheck: `${centerUrl}/agent/course/courseware/learn/check`, //去学习校验--第一次校验
    secondCheck: `${centerUrl}/agent/course/courseware/business/check`, //多项目时候校验---第二次校验
    learnCheck: `${centerUrl}/user/learn-business/v1/check`
};
//获取课件详情
export function handleGetcourseDetail(data) {
    return hMacAjax.get(url.courseDetail, data);
}
// 点击去学习校验
export function handleFirstCheck(data) {
    return hMacAjax.get(url.firstCheck, data);
}
export function handleSecondCheck(data) {
    return hMacAjax.get(url.secondCheck, data);
}
// 校验是否可以学习
export function handleCanLearnCheck(data) {
    return hMacAjax.post(url.learnCheck, data);
}
